import axios from 'axios';

const getAuthHeaders = () => {
  const session = JSON.parse(window.localStorage.getItem('session'));
  return {
    Authorization: session?.accessToken ? `Bearer ${session.accessToken}` : null,
    'Content-Type': 'application/json',
  };
};

const downloadBlob = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const getSanitizedName = (name) => {
  if (!name) return 'all';
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]/g, '_')
    .replace(/__+/g, '_')
    .replace(/^_+|_+$/g, '');
};

class ExportAPI {
  async exportCountings(clientId, startDate, endDate, storeId = null, clientName = null, storeName = null, lang = 'pt') {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const clientSuffix = getSanitizedName(clientName);
    const storeSuffix = getSanitizedName(storeName);
    const tzOffset = new Date().getTimezoneOffset();
    let url = `${process.env.REACT_APP_WEBAPI_URL}/api/gatewaycontagem/export/countings/${clientId}?startDate=${from}&endDate=${to}&lang=${lang}&timezoneOffset=${tzOffset}`;
    if (storeId) url += `&storeId=${storeId}`;
    const response = await axios.get(url, { headers: getAuthHeaders(), responseType: 'blob' });
    downloadBlob(response.data, `countings_${clientSuffix}_${storeSuffix}.xlsx`);
  }

  async exportDashboard(clientId, startDate, endDate, storeId = null, clientName = null, storeName = null, lang = 'pt') {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const clientSuffix = getSanitizedName(clientName);
    const storeSuffix = getSanitizedName(storeName);
    const tzOffset = new Date().getTimezoneOffset();
    let url = `${process.env.REACT_APP_WEBAPI_URL}/api/gatewaycontagem/export/dashboard/${clientId}?startDate=${from}&endDate=${to}&lang=${lang}&timezoneOffset=${tzOffset}`;
    if (storeId) url += `&storeId=${storeId}`;
    const response = await axios.get(url, { headers: getAuthHeaders(), responseType: 'blob' });
    downloadBlob(response.data, `dashboard_${clientSuffix}_${storeSuffix}.xlsx`);
  }

  async exportDwellTime(clientId, startDate, endDate, storeId = null, clientName = null, storeName = null, lang = 'pt') {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const clientSuffix = getSanitizedName(clientName);
    const storeSuffix = getSanitizedName(storeName);
    const tzOffset = new Date().getTimezoneOffset();
    let url = `${process.env.REACT_APP_WEBAPI_URL}/api/gatewaycontagem/export/dwell-time/${clientId}?startDate=${from}&endDate=${to}&lang=${lang}&timezoneOffset=${tzOffset}`;
    if (storeId) url += `&storeId=${storeId}`;
    const response = await axios.get(url, { headers: getAuthHeaders(), responseType: 'blob' });
    downloadBlob(response.data, `dwell_time_${clientSuffix}_${storeSuffix}.xlsx`);
  }
}

export const exportAPI = new ExportAPI();
